import { useQuery } from '@tanstack/react-query';

import type { TypesenseDocument } from '../utils';
import { getTypesenseDocumentById } from './document';
import { useTypesenseAPIKey } from '@/hooks/filters/useTypesenseAPIKey';

interface UseGetTypesenseDocumentByIdProps {
  collection: string | null;
  idField: string | null;
  apiKeyName: string;
  entityId: string | null;
  enabled?: boolean;
}

export const TYPESENSE_DOCUMENT_BY_ID_KEY = 'typesense-document-by-id';

export const useGetTypesenseDocumentById = ({
  collection,
  idField,
  apiKeyName,
  entityId,
  enabled = true,
}: UseGetTypesenseDocumentByIdProps) => {
  const { apiKey } = useTypesenseAPIKey(apiKeyName);

  return useQuery<TypesenseDocument | null>({
    queryKey: [
      collection,
      TYPESENSE_DOCUMENT_BY_ID_KEY,
      idField,
      entityId,
      apiKey,
    ],
    queryFn: () =>
      getTypesenseDocumentById(collection!, idField!, entityId!, apiKey!),
    enabled: enabled && !!collection && !!idField && !!entityId && !!apiKey,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};
